import api from '@/api';

const { $student } = api;

export const { $studentCareer } = $student;
